import {
  ActivitiesModel,
  ActivityGraphWidgetDataModel,
  ContactReferenceModel,
  ItemBreakDownGraphModel,
  NewOrdersModel,
  RecentPaymentActivityModel,
  SubscriptionActivityModel,
} from "../../shared/models";
import { makeAutoObservable } from "mobx";

export default class DashboardStore {
  public paymentWidgetData: RecentPaymentActivityModel;
  public customersWidgetData: ContactReferenceModel[] = [];
  public activityWidgetData: ActivitiesModel = new ActivitiesModel();
  public subscriptionWidgetData: SubscriptionActivityModel;
  public newOrdersWidgetData: NewOrdersModel;
  public activityGraphWidgetData: ActivityGraphWidgetDataModel;
  public itemBreakDownGraphData: ItemBreakDownGraphModel =
    new ItemBreakDownGraphModel();
  constructor() {
    this.paymentWidgetData = new RecentPaymentActivityModel();
    this.subscriptionWidgetData = new SubscriptionActivityModel();
    this.newOrdersWidgetData = new NewOrdersModel();
    this.activityGraphWidgetData = new ActivityGraphWidgetDataModel();

    makeAutoObservable(this);
  }

  updateRecentPaymentActivities(data: RecentPaymentActivityModel): void {
    this.paymentWidgetData = new RecentPaymentActivityModel(data);
  }

  updateCustomers(data: ContactReferenceModel[]): void {
    this.customersWidgetData = data.map((c) => new ContactReferenceModel(c));
  }

  updateActivities(data: ActivitiesModel): void {
    this.activityWidgetData = new ActivitiesModel(data);
  }

  updateSubscriptionActivities(data: SubscriptionActivityModel): void {
    this.subscriptionWidgetData = new SubscriptionActivityModel(data);
  }

  updateNewOrders(data: NewOrdersModel): void {
    this.newOrdersWidgetData = new NewOrdersModel(data);
  }

  updateActivityGraph(data: ActivityGraphWidgetDataModel): void {
    // const graphData: ActivityGraphDataModel[] = [];
    // for (let i = 0; i < 60; i = i + 3) {
    //     const month = i > 30 ? 7 : i % 2 === 0 ? 5 : 6;
    //     const value = Math.floor(Math.random() * (500 - 50 + 1) + 50);
    //     graphData.push(
    //         new ActivityGraphDataModel({
    //             value: value,
    //             date: new Date(2024, month, i + 1),
    //             currentPeriodValue: month === 6 ? value : 0,
    //             priorPeriodValue: month === 5 ? value : 0,
    //             projectedValue: month === 7 ? value : 0,
    //             isCurrentPeriod: month === 6,
    //             isPriorPeriod: month === 5,
    //             isProjected: month === 7,
    //         }),
    //     );
    // }
    this.activityGraphWidgetData = new ActivityGraphWidgetDataModel(data);
  }

  updateItemBreakDownGraph(data: ItemBreakDownGraphModel): void {
    this.itemBreakDownGraphData = new ItemBreakDownGraphModel(data);
  }
}
